<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="showPopup"
    append-to-body
    class="request-form-dialog"
    custom-class="request-form-modal category-request-modal">
    <div slot="title" class="request-modal-titlebar">
      <h2>{{dialogTitle}}</h2>
    </div>

    <el-form
      :label-position="'top'"
      :inline="false"
      label-width="100%"
      :model="selectedObject"
      :rules="rules"
      ref="my-form"
      class="request-form"
      @submit.prevent="save"
      v-loading="loading">
      <section class="request-panel">
        <div class="request-panel-heading">{{$t('categories.basic_information')}}</div>
        <div class="request-field-grid two-columns">
          <el-form-item :label="$t('categories.name')" prop="Name" :required="true">
            <el-input v-model="selectedObject.Name" autofocus></el-input>
          </el-form-item>

          <el-form-item :label="$t('categories.old_product_price')" prop="OldProductPrice" :required="true">
            <el-input-number
              v-model="selectedObject.OldProductPrice"
              controls-position="right"
              :min="0"
              :step="0.1"
              class="full-width">
            </el-input-number>
          </el-form-item>
        </div>
      </section>
    </el-form>

    <span slot="footer" class="request-modal-footer">
      <el-button @click="showPopup=false">{{ $t("cancel") }}</el-button>
      <el-button type="primary" :loading="loading" @click="save">{{ submitLabel }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import settings from "./../../backend/LocalSettings";

export default {
  name: "category-dialog",
  data () {
    return { 
      loading: false,
      showPopup: false,
      mode: 'add',
      selectedObject: {},
      request_new_mode: 0,
      rules: {
          Name:            [ { required: true, message: this.$t('products.required_name') } ],
          OldProductPrice: [ { required: true, message: this.$t('products.required_old_product_price') } ],
      }
    }
    
  },
  computed: {
    dialogTitle: function() {
      return this.request_new_mode ? this.$t("categories.request_dialog_title") : this.$t("categories.dialog_title");
    },
    submitLabel: function() {
      return this.request_new_mode ? this.$t("categories.submit_request") : this.$t("confirm");
    }
  },
  methods: {
     show_me: function( selectedObject, request_new_mode = 0  ) {
         this.mode = "edit";
        if( selectedObject == null ) {
            selectedObject = { OldProductPrice: 10 };
            this.mode = "add";
        }
        this.request_new_mode = request_new_mode;
        this.showPopup        = true;
        this.selectedObject   = JSON.parse( JSON.stringify( selectedObject ) );
    },
    load_info: function(){
        //aici incarcam dropdownuri sau alte elemente, la nevoie
    },
    save: function() {
        this.$refs['my-form'].validate((valid) => {
          if (valid) {
            this.loading = true;
            this.$http
            .post('categories/save',  { mode: this.mode, object: this.selectedObject, request_new_mode: this.request_new_mode } )
            .then(function (response) {
                this.loading = false;
                if( settings.verify_response(response, this.$rights)) {
                this.showPopup = false;
                this.$emit("save");
                } else {
                this.$router.push("/");
                }
            });
          }
        });
    }
  },
  mounted: function() {
      this.load_info();
  }
};
</script>

<style lang="less">
@import "../../styles/request-dialog.less";
</style>
